import React, { useState, useContext, useEffect } from "react";
import { View, StyleSheet, ScrollView } from "react-native";
import NtText from "../../components/NtText";
import NtActivityIndicator from "../../components/NtActivityIndicator";
import UserContext from "../../context/UserContext";
import { useTheme } from "../../context/ThemeContext";
import NtModalUnactiveButton from "../../components/NtModalUnactiveButton";
import NtModalActiveButton from "../../components/NtModalActiveButton";
import NtModalInputField from "../../components/NtModalInputField";
import Logger from "../../common/utils/Logger";
import { parseError } from "@ntconnect/framework/pbx";
import NtTabController from "../../components/NtTabController";
import {
  fetchExtension,
  fetchExtensions,
  updateExtension,
} from "../../api/extension";
import ringgroupstrategytypesdata from "../data/ringgroupstrategytypesdata";
import NtListHeader from "../../components/NtListHeader";
import NtListRow from "../../components/NtListRow";
import NtExtensionTag from "../../components/NtExtensionTag";
import { fetchRingGroups, updateRingGroup } from "../../api/ringgroup";
import NtModalAccountPickerField from "./NtModalAccountPickerField";
import NtSearchBar from "../../components/NtSearchBar";
import settings from "../../config/settings";
import NtPagination from "../../components/NtPagination";
import NtTouchableEffect from "../../components/NtTouchableEffect";
import { parseExtension } from "../utils/ExtensionUtils";
import NtMaterialIcon from "../../components/NtMaterialIcon";
import { fetchVoicemailBox } from "../../api/voicemail";
import { fetchRecordings } from "../../api/recording";
import NtModalTitle from "../../components/NtModalTitle";
import NtModalSubtitle from "../../components/NtModalSubtitle";

let page = 1;

function NtModalAccountPicker({
  item,
  onCancel,
  onPress,
  defaultOpenTab,
  defaultSelectedItem,
  removeOptions = [],
}) {
  let tabs = [
    {
      id: "extension",
      title: "Extension",
      columns: [
        {
          id: "extension",
          title: "Extension",
          default: true,
        },
        {
          id: "effective_caller_id_name",
          title: "Name",
          default: true,
        },
      ],
      request: async (page, search) => {
        return await fetchExtensions(
          context.user?.domain,
          page,
          settings.pageSizeLoad,
          search,
          {}
        );
      },
    },
    {
      id: "ringgroup",
      title: "Ring Group",
      columns: [
        {
          id: "ring_group_extension",
          title: "Extension",
          default: true,
        },
        {
          id: "ring_group_caller_id_name",
          title: "Name",
          default: true,
        },
      ],
      request: async (page, search) => {
        return await fetchRingGroups(
          context.user?.domain,
          page,
          settings.pageSizeLoad,
          search,
          {}
        );
      },
    },
    {
      id: "voicemail",
      title: "Voicemail",
      columns: [
        {
          id: "voicemail_id",
          title: "Extension",
          default: true,
        },
        {
          id: "voicemail_id",
          title: "Name",
          default: true,
        },
      ],
      request: async (page, search) => {
        return await fetchVoicemailBox(
          context.user?.domain,
          "all",
          page,
          settings.pageSizeLoad,
          search,
          {}
        );
      },
    },
    {
      id: "recording",
      title: "Recording",
      columns: [
        {
          id: "recording_name",
          title: "Name",
          default: true,
        },
        {
          id: "recording_filename",
          title: "Filename",
          default: true,
        },
      ],
      request: async (page, search) => {
        const response = await fetchRecordings(
          context.user?.domain,
          page,
          settings.pageSizeLoad,
          search,
        );
        return response;
      },
    },
    {
      id: "other",
      title: "Other",
      columns: [
        {
          id: "action",
          title: "Action",
          default: true,
        },
        {
          id: "description",
          title: "Description",
          default: true,
        },
      ],
      request: async (page, search) => {
        // Each row carries the exact backend action mapping (name/value).
        // The backend ivrActionSchema requires `value` to be null for
        // hangup/top-menu/back and these rows won't render in non-IVR
        // contexts where only hangup is meaningful, but the proper mapping
        // is the same regardless of caller.
        const data = [
          {
            action: "Hangup",
            description: "Hangup the call",
            name: "hangup",
            value: null,
          },
          {
            action: "Top Menu",
            description: "Return to the top-level IVR menu",
            name: "top-menu",
            value: null,
          },
          {
            action: "Back",
            description: "Return to the previous menu",
            name: "back",
            value: null,
          },
        ];

        return {
          ok: true,
          data: { data: data },
        };
      },
    },
  ];

  // Will remove the options from the array....
  if (removeOptions && removeOptions?.length > 0) {
    removeOptions.map((eachRemove) => {
      tabs = tabs.filter((each) => each.id != eachRemove);
    });
  }

  const [tab, setTab] = useState(tabs[0]);
  const [search, setSearch] = useState("");
  const [data, setData] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [loading, setLoading] = useState(false);
  const context = useContext(UserContext);
  const { theme } = useTheme();

  const fetchApp = () => {
    return "transfer";
  };

  const fetchData = () => {
    if (tab?.id == "extension") {
      return `${parseExtension(item[tab?.columns[0]?.id])} XML ${
        context.user?.domain
      }`;
    } else if (tab?.id == "ringgroup") {
      return `${item[tab?.columns[0]?.id]} XML ${
        context.user?.domain
      }`;
    } else if (tab?.id == "voicemail") {
      return `*99${item[tab?.columns[0]?.id]} XML ${
        context.user?.domain
      }`;
    }
  };

  const renderTabs = (containerStyle) => {
    return (
      <View
        style={[{ flexDirection: "row", alignItems: "center" }, containerStyle]}
      >
        <NtTabController
          containerStyle={{ marginTop: 4 }}
          options={tabs}
          selection={tab}
          onPress={(item) => {
            setTab(item);
            setSearch("");

            page = 1;
            handleDataFetch(item, "");
          }}
        />

        {loading && (
          <NtActivityIndicator
            color={theme.brand}
            size="small"
            containerStyle={{ marginLeft: 10 }}
          />
        )}
      </View>
    );
  };

  const handleDataFetch = async (tab, search) => {
    Logger("Fetching Account Picker data for tab", tab);

    setLoading(true);

    const response = await tab?.request(page, search);
    Logger("Account Picker fetch response", response);

    if (response.ok) {
      // Page-replace pagination — every page fetch shows just that page's
      // records, so the parent list never grows beyond pageSizeLoad.
      setData(response.data?.data || []);
      setTotalItems(response.data?.total || 0);
    }
    setLoading(false);
  };

  const handleSearch = (text) => {
    setSearch(text);
    page = 1;
    handleDataFetch(tab, text);
  };

  useEffect(() => {
    let tab = tabs[0];
    if (defaultOpenTab) {
      const response = tabs?.find((each) => each.id == defaultOpenTab);
      if (response) {
        tab = response;
      }
    }
    setTab(tab);
    page = 1;
    handleDataFetch(tab, search);
  }, []);

  const renderRow = (item, index) => {
    const isSelected = item[tab?.columns[0].id] == defaultSelectedItem;

    return (
      <NtTouchableEffect
        key={tab?.id + index}
        onPress={() => {
          if (onPress) {
            // Rows on the Other tab carry their own backend `name`/`value`
            // mapping; everywhere else the action name comes from the tab
            // and the value from the first column.
            const data = {
              item: item,
              tab: tab,
              name: item?.name || tab?.id,
              value:
                item?.value !== undefined ? item.value : item[tab?.columns[0].id],
            };

            onPress(data);
          }
        }}
      >
        <NtListRow
          item={item}
          columns={tab?.columns}
          renderCustom={(row, column) => {
            if (column === "extension") {
              return <NtExtensionTag extension={row[column]} />;
            }
          }}
          renderAction={
            <NtMaterialIcon
              name="check"
              color={isSelected ? theme.green : "transparent"}
            />
          }
        />
      </NtTouchableEffect>
    );
  };

  return (
    <View style={styles.container}>
      <NtModalTitle>Select Account</NtModalTitle>
      <NtModalSubtitle style={[{ marginTop: 4 }]}>
        Select account from{" "}
        <NtText style={{ fontWeight: "900" }}>{tab?.title}</NtText> list
      </NtModalSubtitle>

      {renderTabs({ marginTop: 8 })}

      {tab?.id != "other" && (
        <NtSearchBar
          containerStyle={{ marginTop: 25, marginBottom: 15 }}
          value={search}
          onChangeText={(text) => {
            handleSearch(text);
          }}
        />
      )}

      <ScrollView
        contentContainerStyle={{ flexGrow: 1 }}
        showsVerticalScrollIndicator={false}
      >
        <NtListHeader
          selectedColumns={tab?.columns}
          headerContainerStyle={{ marginRight: 14 }}
        />

        {data?.map((each, index) => renderRow(each, index))}
      </ScrollView>

      {tab?.id !== "other" ? (
        <NtPagination
          page={page}
          pageSize={settings.pageSizeLoad}
          total={totalItems}
          onChange={(nextPage) => {
            page = nextPage;
            handleDataFetch(tab, search);
          }}
        />
      ) : null}

      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "flex-end",
          marginTop: 25,
        }}
      >
        <NtModalUnactiveButton title={"Cancel"} onPress={onCancel} />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    minWidth: 500,
    maxWidth: 600,
    minHeight: 500,
    maxHeight: 800,
    padding: 15,
  },
});

export default NtModalAccountPicker;
